var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rol=='empleado')?[_c('DashboardNominas')]:_vm._e(),(_vm.rol!='empleado')?[(_vm.rol == 'root')?[_c('DashboardNominas')]:(_vm.rol == 'admin-depto')?[_c('DashboardGDTH')]:[(_vm.tipoDashboard == 'gdth')?[_c('DashboardGDTH')]:[_c('DashboardNominas')]]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }